export default __webpack_public_path__ + "static/media/srishty.f51b9ead.jpeg";